import React from 'react';
import { Box, Typography } from '@mui/material';
import IntlMessages from '@projectK/helpers/IntlMessages';
import { Fonts } from '@projectK/constants/AppEnums';
import ChangePasswordForm from './ChangePasswordForm';
import { Formik } from 'formik';
import * as yup from 'yup';
import jwtAxios from '@projectK/services/auth/JWT';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import AppInfoView from '@projectK/components/AppInfoView';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import {isActualSuperAdmin,isActualAdmin } from '@projectK/context/RolesProvider';

const validationSchema = yup.object({
  old_password: yup
    .string()
    .required(<IntlMessages id='validation.passwordRequired' />)
    .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
  password: yup
    .string()
    .required(<IntlMessages id='validation.passwordRequired' />)
    .min(8, () => <IntlMessages id='validation.passwordTooShort' />)
    .matches(
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-])/,
      () => <IntlMessages id='validation.passwordWeak' />,
    ),
  repeat_password: yup
    .string()
    .required('Please enter confirm password.')
    .oneOf([yup.ref('password'), null], 'Password must match.'),
});

const ChangePassword = () => {
  const companyTheme = CompanyTheme();
  const infoViewActionsContext = useInfoViewActionsContext();
  const { user } = useAuthUser();
  return (
    <>
      <Box>
        <Typography
          component='h3'
          sx={{
            fontSize: 16,
            fontWeight: Fonts.BOLD,
            mb: { xs: 3, lg: 5 },
            color: companyTheme ? companyTheme.primary.main : 'text.primary',
          }}
        >
          <IntlMessages id='common.changePassword' />
        </Typography>
        <Formik
          validateOnChange={true}
          validateOnBlur={true}
          initialValues={{
            old_password: (isActualSuperAdmin(user) ||isActualAdmin(user))
              ? 'texting123'
              : '',

            password: '',
            repeat_password: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            const { date_of_birth, ...rest } = values;
            jwtAxios
              .post(`/auth/update-password`, {
                ...rest,
              })
              .then((response) => {
                setSubmitting(false);
                resetForm();
                infoViewActionsContext.showMessage(
                  'Password updated successfully!',
                );
              })
              .catch((error) => {
                infoViewActionsContext.fetchError(error.response.data.error);
                setSubmitting(false);
              });
          }}
        >
          {(formikProps) => (
            <ChangePasswordForm
              companyTheme={companyTheme}
              resetForm={formikProps.resetForm}
              user={user}
            />
          )}
        </Formik>
      </Box>
      <AppInfoView />
    </>
  );
};

export default ChangePassword;
